import Swal from 'sweetalert2'
import { capitalize } from 'lodash'

const ALERT_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  QUESTION: 'question'
}

const alertError = function (message) {
  const option = {
    type: ALERT_TYPE.ERROR,
    text: capitalize(message)
  }

  Swal.fire(option)
}

const alertErrorWithHtml = function (message) {
  const option = {
    type: ALERT_TYPE.ERROR,
    html: message
  }

  Swal.fire(option)
}

const alertConfirmDelete = async function (message, confirmButtonText = 'Confirm', cancelButtonText = 'Cancel') {
  const option = {
    type: ALERT_TYPE.WARNING,
    html: message,
    confirmButtonText: confirmButtonText,
    confirmButtonColor: '#d33',
    cancelButtonText: cancelButtonText,
    showCancelButton: true
  }

  const result = await Swal.fire(option)
  return result.hasOwnProperty('value')
}

export default {
  methods: {
    alertError,
    alertConfirmDelete,
    alertErrorWithHtml
  }
}
